module.exports = __webpack_public_path__ + "img/11.b10cd9de.jpg";